import { useEffect, useRef } from "react"
import { gsap } from "gsap"
import SpinningLogoComponent from "../spinning-logo/spinning-logo.component"
import "./loader.component.css"

const LoaderComponent = () => {
  const isVisible = useRef(false)

  useEffect(() => {
    const handleStartLoader = () => {
      if (isVisible.current) return
      isVisible.current = true

      // Kill any in-progress tweens on the overlay to prevent conflicts
      gsap.killTweensOf(".dagger-loader-overlay")
      gsap.killTweensOf(
        ".dagger-loader-overlay .dagger-spinning-logo svg path",
      )
      gsap.killTweensOf(".dagger-loader-caption")

      // Snap the overlay visible immediately so the page transition is hidden
      gsap.set(".dagger-loader-overlay", {
        opacity: 1,
        pointerEvents: "auto",
        backgroundColor: "#210038",
      })

      // Logo can still fade in for a polished feel
      gsap.fromTo(
        [
          ".dagger-loader-overlay .dagger-spinning-logo svg path",
          ".dagger-loader-caption",
        ],
        {
          fill: "#210038",
          color: "#210038",
        },
        {
          fill: "#fafafa",
          color: "#fafafa",
          duration: 0.35,
          ease: "power3.inOut",
        },
      )
    }

    const handleStopLoader = () => {
      if (!isVisible.current) return

      gsap.to(".dagger-loader-overlay", {
        duration: 0.6,
        ease: "power2.inOut",
        opacity: 0,
        delay: 0,
        onComplete: () => {
          isVisible.current = false
          gsap.set(".dagger-loader-overlay", {
            pointerEvents: "none",
          })
        },
      })
    }

    // Fade in on initial mount
    handleStartLoader()

    document.addEventListener("EVENTS.START_LOADING", handleStartLoader)
    document.addEventListener("EVENTS.STOP_LOADING", handleStopLoader)

    return () => {
      document.removeEventListener("EVENTS.START_LOADING", handleStartLoader)
      document.removeEventListener("EVENTS.STOP_LOADING", handleStopLoader)
    }
  }, [])

  return (
    <div className="dagger-loader-overlay">
      {<SpinningLogoComponent isLoading />}
      <div className="dagger-loader-slide" />
      <div className="dagger-loader-tiles">
        <div className="dagger-loader-tile" />
        <div className="dagger-loader-tile" />
        <div className="dagger-loader-tile" />
        <div className="dagger-loader-tile" />
        <div className="dagger-loader-tile" />
      </div>
    </div>
  )
}

export default LoaderComponent
